import React, { Suspense, useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { Panel, Tab, Col, Row, Nav, NavItem, Form, Button } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { navigate } from 'raviger';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';
import withForm from '../../hoc/withForm';
import OptionsHelper from '../../lib/OptionsHelper';
import ConfirmationModal from '../../components/Modals/ConfirmationModal/ConfirmationModal';

import { useAlertStore } from '../../store/providers/Alert';
import { useActivityPlansStore } from '../../store/providers/ActivityPlans';
import { useActivityTemplateStore } from '../../store/providers/ActivityTemplates';
import Permission from '../../components/Permission/Permission';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import Spinner from '../../components/Spinner/Spinner';

import './ActivityPlan.css';
import moment from 'moment';
import * as constants from '../../constants';

const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const Reminder = React.lazy(() => import('./FormSections/Reminder'));
const PerformActivity = React.lazy(() => import('./FormSections/PerformActivity'));
const AlternateDays = React.lazy(() => import('./FormSections/AlternateDays'));
const AssignTo = React.lazy(() => import('./FormSections/AssignTo'));
const CallScript = React.lazy(() => import('./FormSections/CallScript'));
const ActivityFor = React.lazy(() => import('./FormSections/ActivityFor'));
const LetterTemplate = React.lazy(() => import('./FormSections/LetterTemplate'));
const EmailTemplate = React.lazy(() => import('./FormSections/EmailTemplate'));
const SmsTemplate = React.lazy(() => import('./FormSections/SmsTemplate'));
const Name = React.lazy(() => import('./FormSections/Name'));
const Instance = React.lazy(() => import('./FormSections/Instance'));

function ActivityPlanTemplate(props) {
    const dispatch = useDispatch();
    const { addAlert } = useAlertStore();
    const { selectRecord, newRecord, createRecord, data, clearData,
        listBusinessDayTypes, listOperators, listTriggeringFields, listTriggeringImmediateFields, listPrecedingActivities, listFileCompleteStatuses, listSettlementStatementStatuses,
        listTransactionStatusTriggers, listAgentStatusTriggers, listSecurityRoles, listSeverReasons, listActivityTargets, listActivityAgentTypeTargets, listInstanceTypes, listDepartmentEmailActivityTargets } = useActivityTemplateStore();
    const { selectRecord: selectRecordPlan, data: dataPlan, createRecord: createPlanRecord } = useActivityPlansStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isNew, setIsNew] = useState(false);
    const [isBusy, setIsBusy] = useState(false);

    const pagePermission = constants.PERMISSION_CONTENT_ACTIVITYPLANS_ACTIVITYPLAN_ACTIVITYTEMPLATE;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const [activityPlan, setActivityPlan] = useState('');
    const [activityPlanId, setActivityPlanId] = useState('');
    const [activityTemplate, setActivityTemplate] = useState('');
    const [assignToTrigger, setAssignToTrigger] = useState('');
    const [radioPerformSelected, setRadioPerformSelected] = useState('');
    const [showTabChangeModal, setShowTabChangeModal] = useState(false);

    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoadedPlan, setIsLoadedPlan] = useState(false);
    const [isLoadedFull, setIsLoadedFull] = useState(false);
    const [selectedTab, setSelectedTab] = useState('todo');
    const [preSelectedTab, setPreSelectedTab] = useState();
    const [templateName, setTemplateName] = useState('');

    const [isListingAgents, setIsListingAgents] = useState();
    const [isSellingAgents, setIsSellingAgents] = useState();
    const [isSellers, setIsSellers] = useState();
    const [isBuyers, setIsBuyers] = useState();
    const [isListingInhouseTransactionCoordinator, setIsListingInhouseTransactionCoordinator] = useState();
    const [isSellingInhouseTransactionCoordinator, setIsSellingInhouseTransactionCoordinator] = useState();

    const [isListingSideBranchManager, setIsListingSideBranchManager] = useState();
    const [isSellingSideBranchManager, setIsSellingSideBranchManager] = useState();

    const [isAgentCategory, setIsAgentCategory] = useState();
    const [isRentalCategory, setIsRentalCategory] = useState(false);

    const [recurringTriggerIds] = useState([495, 496, 210, 66, 480, 674]);

    const [triggerFieldTypeId, setTriggerFieldTypeId] = useState();
    const [triggerFieldTypeIdImmediate, setTriggerFieldTypeIdImmediate] = useState();

    const [listSecurityRolesData, setListSecurityRolesData] = useState([]);
    const [listSecurityRolesOptions, setListSecurityRolesOptions] = useState([]);

    const [listInstanceTypeData, setListInstanceTypeData] = useState([]);
    const [listInstanceTypeOptions, setListInstanceTypeOptions] = useState([]);

    const [listBusinessDayTypesData, setListBusinessDayTypesData] = useState([]);
    const [listBusinessDayTypesOptions, setListBusinessDayTypesOptions] = useState([]);

    const [listOperatorsData, setListOperatorsData] = useState([]);
    const [listOperatorsOptions, setListOperatorsOptions] = useState([]);

    const [listTriggeringFieldsData, setListTriggeringFieldsData] = useState([]);
    const [listTriggeringFieldsOptions, setListTriggeringFieldsOptions] = useState([]);

    const [listAgentStatusTriggerData, setListAgentStatusTriggerData] = useState([]);
    const [listAgentStatusTriggerOptions, setListAgentStatusTriggerOptions] = useState([]);

    const [listTriggeringImmediateFieldsData, setListTriggeringImmediateFieldsData] = useState([]);
    const [listTriggeringImmediateFieldsOptions, setListTriggeringImmediateFieldsOptions] = useState([]);

    const [listPrecedingActivitiesData, setListPrecedingActivitiesData] = useState([]);
    const [listPrecedingActivitiesOptions, setListPrecedingActivitiesOptions] = useState([]);

    const [listFileCompleteStatusesData, setListFileCompleteStatusesData] = useState([]);
    const [listFileCompleteStatusesOptions, setListFileCompleteStatusesOptions] = useState([]);

    const [listSettlementStatementStatusesData, setListSettlementStatementStatusesData] = useState([]);
    const [listSettlementStatementStatusOptions, setListSettlementStatementStatusesOptions] = useState([]);

    const [listSeverReasonsData, setlistSeverReasonsData] = useState([]);

    const [listTransactionStatusTriggerData, setListTransactionStatusTriggerData] = useState([]);
    const [selectedTransactionStatusTriggerOptions, setSelectedTransactionStatusTriggerOptions] = useState([]);

    const [listActivityTargetsData, setListActivityTargetsData] = useState([]);
    const [listActivityTargetsOptions, setListActivityTargetsOptions] = useState([]);

    const [listActivityAgentTypeTargetsData, setListActivityAgentTypeTargetsData] = useState([]);
    const [listActivityAgentTypeTargetsOptions, setListActivityAgentTypeTargetsOptions] = useState([]);

    const [listDepartmentEmailActivityTargetsData, setListDepartmentEmailActivityTargetsData] = useState([]);
    const [listDepartmentEmailActivityTargetsOptions, setListDepartmentEmailActivityTargetsOptions] = useState([]);
    const [isDepartmentEmailActivityTarget, setIsDepartmentEmailActivityTarget] = useState(false);

    const [activityTypeValues, setActivityTypeValues] = useState([]);
    const [isDisableAddingPlan, setIsDisableAddingPlan] = useState(false);

    const [validations, setValidations] = useState([]);
    const sellersActivityTargetType = 290;
    const buyersActivityTargetType = 291;
    const listingAgentActivityTargetType = 292;
    const sellingAgentActivityTargetType = 293;
    const listingInhouseActivityTargetType = 461;
    const sellingInhouseActivityTargetType = 462;
    const listingBranchManagerActivityTargetType = 463;
    const sellingBranchManagerActivityTargetType = 464;

    const [temporaryPlan, setTemporaryPlan] = useState(
        {
            name: '',
            description: '',
            categoryId: '',
            subCategoryIds: '',
            startDate: '',
            endDate: '',
        }
    )

    useEffect(() => {
        const valid_instance =
        {
            field: 'instanceTypeId',
            method: 'isEmpty',
            validWhen: false,
            message: 'Instance is a required field.'
        };
        const valid_name =
        {
            field: 'name',
            method: 'isEmpty',
            validWhen: false,
            message: 'Name is a required field.'
        };
        const valid_description =
        {
            field: 'description',
            method: 'isEmpty',
            validWhen: false,
            message: 'Description is a required field.'
        };
        const valid_assignToId =
        {
            field: 'assignToId',
            method: 'isEmpty',
            validWhen: false,
            message: 'Assign To is a required field.'
        };
        const valid_emailTemplateId =
        {
            field: 'mailMergeTemplateId',
            method: 'isEmpty',
            validWhen: false,
            message: 'Email Template is a required field.'
        };
        const valid_subjectLine =
        {
            field: 'SubjectLine',
            method: 'isEmpty',
            validWhen: false,
            message: 'Subject Line is a required field.'
        };
        const valid_smsTemplateId =
        {
            field: 'mailMergeTemplateId',
            method: 'isEmpty',
            validWhen: false,
            message: 'SMS Template is a required field.'
        };
        const valid_letterTemplateId =
        {
            field: 'mailMergeTemplateId',
            method: 'isEmpty',
            validWhen: false,
            message: 'Letter Template is a required field.'
        };
        const valid_SelectedListingAgentActivityTargets =
        {
            field: 'SelectedListingAgentActivityTargets',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };
        const valid_SelectedSellingAgentActivityTargets =
        {
            field: 'SelectedSellingAgentActivityTargets',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };
        const valid_dueDays =
        {
            field: 'dueDays',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };
        const valid_operatorId =
        {
            field: 'operatorId',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };
        const valid_triggerFieldTypeId =
        {
            field: 'triggerFieldTypeId',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };
        const valid_precedingActivityId =
        {
            field: 'precedingActivityId',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };
        const valid_triggerTime =
        {
            field: 'triggerTime',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };
        const valid_triggerFieldTypeIdImmediate =
        {
            field: 'triggerFieldTypeIdImmediate',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };
        const valid_dropOffDays =
        {
            field: 'dropOffDays',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };
        const valid_transactionStatusTriggerIds =
        {
            field: 'selectedTransactionStatusIds',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };

        const valid_agentStatusTriggerId =
        {
            field: 'agentStatusTriggerId',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };

        const valid_agentSeverReasonIds =
        {
            field: 'selectedSeverReasonIds',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };

        const valid_agentSeverReasonIdsImmediate =
        {
            field: 'selectedSeverReasonIdsImmediate',
            method: 'isEmpty',
            validWhen: false,
            message: 'Required'
        };


        setValidations([valid_name, valid_description, valid_instance]);

        switch (selectedTab) {
            case 'todo':
                break;
            case 'call':
                break;
            case 'email':
                setValidations(validations => [...validations, valid_emailTemplateId, valid_subjectLine]);
                if (assignToTrigger === "IsAutomaticTrigger" && radioPerformSelected === "performBefore") {
                    setValidations(validations => [...validations, valid_triggerTime]);
                }
                break;
            case 'sms':
                setValidations(validations => [...validations, valid_smsTemplateId]);
                break;
            case 'letter':
                setValidations(validations => [...validations, valid_letterTemplateId]);
                break;
            case 'calendar':
                break;
            default:
                break;
        }

        if (selectedTab != 'calendar' && selectedTab != 'todo' && assignToTrigger === "IsOptional") {
            setValidations(validations => [...validations, valid_assignToId, valid_dropOffDays]);
        }
        if (isListingAgents && !isAgentCategory) {
            setValidations(validations => [...validations, valid_SelectedListingAgentActivityTargets]);
        }
        if (isSellingAgents && !isAgentCategory) {
            setValidations(validations => [...validations, valid_SelectedSellingAgentActivityTargets]);
        }

        if (radioPerformSelected === "performBefore" && ((temporaryPlan && temporaryPlan.categoryId && (parseInt(temporaryPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_AGENT))
            || (activityPlan && activityPlan.categoryId && (parseInt(activityPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_AGENT)))
            && ((temporaryPlan && temporaryPlan.subCategoryIds && temporaryPlan.subCategoryIds.every((x) => x == constants.ACTIVITYPLANAGENTSUBCATEGORY_ACTIVE))
                || (activityPlan && activityPlan.subCategories && activityPlan.subCategories.every((x) => x.subCategoryId == constants.ACTIVITYPLANAGENTSUBCATEGORY_ACTIVE)))) {
            setValidations(validations => [...validations, valid_agentStatusTriggerId]);
        }

        if (parseInt(triggerFieldTypeId) === 180 && radioPerformSelected === "performBefore" && (((temporaryPlan && temporaryPlan.categoryId && (parseInt(temporaryPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_AGENT))
            || (activityPlan && activityPlan.categoryId && (parseInt(activityPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_AGENT)))
            && ((temporaryPlan && temporaryPlan.subCategoryIds && temporaryPlan.subCategoryIds.some((x) => x == constants.ACTIVITYPLANAGENTSUBCATEGORY_SEVERED))
                || (activityPlan && activityPlan.subCategories && activityPlan.subCategories.some((x) => x.subCategoryId == constants.ACTIVITYPLANAGENTSUBCATEGORY_SEVERED))))) {
            setValidations(validations => [...validations, valid_agentSeverReasonIds]);
        }

        if (parseInt(triggerFieldTypeIdImmediate) === 180 && radioPerformSelected === "performImmediately" && (selectedTab == 'email' || selectedTab == 'sms') && (((temporaryPlan && temporaryPlan.categoryId && (parseInt(temporaryPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_AGENT))
            || (activityPlan && activityPlan.categoryId && (parseInt(activityPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_AGENT)))
            && ((temporaryPlan && temporaryPlan.subCategoryIds && temporaryPlan.subCategoryIds.some((x) => x == constants.ACTIVITYPLANAGENTSUBCATEGORY_SEVERED))
                || (activityPlan && activityPlan.subCategories && activityPlan.subCategories.some((x) => x.subCategoryId == constants.ACTIVITYPLANAGENTSUBCATEGORY_SEVERED))))) {
            setValidations(validations => [...validations, valid_agentSeverReasonIdsImmediate]);
        }

        if (radioPerformSelected === "performBefore" && isAgentCategory) {
            setValidations(validations => [...validations, valid_dueDays, valid_operatorId, valid_triggerFieldTypeId]);
        }
        if (radioPerformSelected === "performBefore" && isRentalCategory) {
            setValidations(validations => [...validations, valid_dueDays, valid_operatorId, valid_triggerFieldTypeId]);
        }
        if (radioPerformSelected === "performBefore" && !isAgentCategory && !isRentalCategory) {
            setValidations(validations => [...validations, valid_dueDays, valid_operatorId, valid_transactionStatusTriggerIds, valid_triggerFieldTypeId]);
        }
        if (radioPerformSelected === "performAfter") {
            setValidations(validations => [...validations, valid_precedingActivityId]);
        }
        if (radioPerformSelected === "performImmediately") {
            setValidations(validations => [...validations, valid_triggerFieldTypeIdImmediate]);
        }
    }, [
        selectedTab,
        isSellingAgents,
        isListingAgents,
        radioPerformSelected,
        assignToTrigger,
        temporaryPlan,
        activityPlan,
        isSellers,
        isBuyers,
        isAgentCategory,
        isListingInhouseTransactionCoordinator,
        isSellingInhouseTransactionCoordinator,
        isListingSideBranchManager,
        isSellingSideBranchManager,
        triggerFieldTypeId,
        triggerFieldTypeIdImmediate
    ]);

    useEffect(() => {
        switch (selectedTab) {
            case 'email':
                setAssignToTrigger('IsAutomaticTrigger');
                break;
            case 'sms':
                setAssignToTrigger('IsAutomaticTrigger');
                break;
            default:
                setAssignToTrigger('IsOptional');
                break;
        }
    }, [selectedTab]);

    const tabSelectedHandler = (tabKey) => {
        if (props.formDirty) {
            setPreSelectedTab(tabKey);
            setShowTabChangeModal(true);
        } else {
            setSelectedTab(tabKey);
        }
    };

    const tabSelectedYesHandler = () => {
        props.formInitialize('');
        props.formSetClean(true);
        setActivityTemplate('');
        setTemplateName('');
        setIsLoaded(false);
        setIsMounted(false);
        setIsLoadedFull(false);
        setSelectedTab(preSelectedTab);
        setShowTabChangeModal(false);
    };

    const tabSelectedNoHandler = () => {
        setSelectedTab(selectedTab);
        setShowTabChangeModal(false);
    };

    const submittedTemplateHandler = (e) => {
        e.preventDefault();
        if (radioPerformSelected === "performBefore") {
            props.formData['performBefore'] = 1;
            props.formData['performAfter'] = 0;
            props.formData['performImmediately'] = 0;
        } else if (radioPerformSelected === "performAfter") {
            props.formData['performBefore'] = 0;
            props.formData['performAfter'] = 1;
            props.formData['performImmediately'] = 0;
        } else if (radioPerformSelected === "performImmediately") {
            props.formData['performBefore'] = 0;
            props.formData['performAfter'] = 0;
            props.formData['performImmediately'] = 1;
        }

        var valid = props.formValidate(validations);
        if (valid) {
            props.formSubmitted();

            if (isEmpty(activityPlan) && isEmpty(activityPlan.id)) {
                if (!isEmpty(temporaryPlan)) {
                    createPlanRecord({
                        Id: 0,
                        Name: temporaryPlan.name,
                        Description: temporaryPlan.description,
                        StartDate: temporaryPlan.startDate,
                        EndDate: temporaryPlan.endDate,
                        CategoryId: temporaryPlan.categoryId,
                        SelectedSubCategories: temporaryPlan.subCategoryIds,
                        FranchiseId: null,
                        IsDeleted: 0
                    });
                }
            } else {
                savePlanTemplate(activityPlan.id);
            }
        }
    }

    const savePlanTemplate = (planId) => {
        const selectedActivityTargets = [];
        if (isListingAgents && props.formData.SelectedListingAgentActivityTargets) selectedActivityTargets.push(listingAgentActivityTargetType);
        if (isSellingAgents && props.formData.SelectedSellingAgentActivityTargets) selectedActivityTargets.push(sellingAgentActivityTargetType);
        if (isSellers && props.formData.IsActivityTargetForSellers) selectedActivityTargets.push(sellersActivityTargetType);
        if (isBuyers && props.formData.IsActivityTargetForBuyers) selectedActivityTargets.push(buyersActivityTargetType);
        if (isListingInhouseTransactionCoordinator && props.formData.IsActivityTargetForListingInhouseTransactionCoordinator) selectedActivityTargets.push(listingInhouseActivityTargetType);
        if (isSellingInhouseTransactionCoordinator && props.formData.IsActivityTargetForSellingInhouseTransactionCoordinator) selectedActivityTargets.push(sellingInhouseActivityTargetType);
        if (isListingSideBranchManager && props.formData.IsActivityTargetForListingSideBranchManagers) selectedActivityTargets.push(listingBranchManagerActivityTargetType);
        if (isSellingSideBranchManager && props.formData.IsActivityTargetForSellingSideBranchManagers) selectedActivityTargets.push(sellingBranchManagerActivityTargetType);
        if (isDepartmentEmailActivityTarget && props.formData.SelectedDepartmentEmailActivityTarget !== undefined && props.formData.SelectedDepartmentEmailActivityTarget !== null) selectedActivityTargets.push(props.formData.SelectedDepartmentEmailActivityTarget);

        let triggerTime = '';
        if (props.formData.triggerTime) {
            triggerTime = moment(props.formData.triggerTime).local().format('YYYY-MM-DDTHH:mm:ss');
            if (triggerTime === 'Invalid date') {
                const today = new Date();
                const dateTime = today.getFullYear() + '-' + (today.getMonth()) + '-' + today.getDate() + ' ' + props.formData.triggerTime;
                triggerTime = moment(dateTime).local().format('YYYY-MM-DDTHH:mm:ss');
            }
        }

        createRecord({
            Id: (props.formData.id) ? props.formData.id : 0,
            InstanceTypeId: props.formData.instanceTypeId,
            Name: props.formData.name,
            Description: (props.formData.description) ? props.formData.description : null,
            IsUrgent: props.formData.IsUrgent ? 1 : 0,
            ActivityPlanId: (!isEmpty(activityPlan.id) ? activityPlan.id : (planId ? planId : null)),

            ActivityTemplateId: (props.activityTemplateId) ? parseInt(props.activityTemplateId) : 0,
            CategoryId: (activityPlan.categoryId) ? activityPlan.categoryId : (temporaryPlan.categoryId ? temporaryPlan.categoryId : null),
            ActivityTypeId: activityTypeValues.filter(value => value.alias.toString() === selectedTab.toString())[0].id,

            AssignToId: (props.formData.assignToId) ? props.formData.assignToId : 0,
            IsAutomaticTrigger: (selectedTab === 'email' && assignToTrigger === 'IsAutomaticTrigger') ? 1 : ((selectedTab === 'sms') ? 1 : ((selectedTab === 'calendar') ? 1 : 0)),
            IsOptional: (selectedTab === 'email' && assignToTrigger === 'IsAutomaticTrigger') ? 0 : ((selectedTab === 'sms') ? 0 : ((selectedTab === 'calendar') ? 0 : 1)),

            SelectedListingAgentActivityTargets: (isListingAgents && props.formData.SelectedListingAgentActivityTargets) ? [props.formData.SelectedListingAgentActivityTargets] : null,
            SelectedSellingAgentActivityTargets: (isSellingAgents && props.formData.SelectedSellingAgentActivityTargets) ? [props.formData.SelectedSellingAgentActivityTargets] : null,
            SelectedActivityTargets: selectedActivityTargets,

            PrecedingActivityId: (props.formData.precedingActivityId) ? parseInt(props.formData.precedingActivityId) : 0,
            ExecutionTypeId: (props.formData.performAfter && props.formData.precedingActivityId)
                ? constants.ACTIVITYPLANEXECUTIONTYPE_AFTERPRECEDING
                : ((props.formData.performImmediately)
                    ? constants.ACTIVITYPLANEXECUTIONTYPE_PERFORMIMMEDIATELY
                    : constants.ACTIVITYPLANEXECUTIONTYPE_PERFORMEVENT),

            DueDays: (props.formData.performBefore && props.formData.dueDays) ? parseInt(props.formData.dueDays) : null,
            OperatorId: (props.formData.performBefore && props.formData.operatorId) ? parseInt(props.formData.operatorId) : null,
            FileCompleteStatusId: (props.formData.performBefore && props.formData.fileCompleteStatusId)
                ? parseInt(props.formData.fileCompleteStatusId)
                : ((props.formData.performImmediately && props.formData.fileCompleteStatusIdImmediate)
                    ? parseInt(props.formData.fileCompleteStatusIdImmediate)
                    : null),
            SettlementStatementStatusId: (props.formData.performBefore && props.formData.settlementStatementStatusId)
                ? parseInt(props.formData.settlementStatementStatusId)
                : null,
            SelectedTransactionStatusIds: (props.formData.performBefore && props.formData.selectedTransactionStatusIds)
                ? props.formData.selectedTransactionStatusIds.map((item) => item.id)
                : [],
            AgentStatusTriggerId: (props.formData.performBefore && props.formData.agentStatusTriggerId)
                ? parseInt(props.formData.agentStatusTriggerId)
                : null,
            TriggerFieldTypeId: (props.formData.performBefore && props.formData.triggerFieldTypeId)
                ? parseInt(props.formData.triggerFieldTypeId)
                : ((props.formData.performImmediately && props.formData.triggerFieldTypeIdImmediate)
                    ? parseInt(props.formData.triggerFieldTypeIdImmediate)
                    : null),
            TriggerTime: (assignToTrigger === 'IsAutomaticTrigger' && props.formData.performBefore && props.formData.triggerTime) ? triggerTime : null,

            isRecurring: ((parseInt(activityPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_AGENT || parseInt(temporaryPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_AGENT) && recurringTriggerIds.some(item => item === parseInt(props.formData.triggerFieldTypeId))) ? props.formData.isRecurring : 0,

            SelectedSeverReasonIds: (props.formData.performBefore && props.formData.selectedSeverReasonIds)
                ? props.formData.selectedSeverReasonIds.map((item) => item.id)
                : ((props.formData.performImmediately && props.formData.selectedSeverReasonIdsImmediate)
                    ? props.formData.selectedSeverReasonIdsImmediate.map((item) => item.id)
                    : []),

            SaturdayAlternateDayId: props.formData.saturdayAlternateDayId,
            SundayAlternateDayId: props.formData.sundayAlternateDayId,

            ReminderSendDays: (props.formData.reminderSendDays) ? parseInt(props.formData.reminderSendDays) : null,
            ReminderOperatorId: (props.formData.reminderSendDays) ? 303 : null,
            DropOffDays: (props.formData.dropOffDays) ? parseInt(props.formData.dropOffDays) : 0,
            DropOffOperatorId: (props.formData.dropOffDays) ? 302 : null,

            MailMergeTemplateId: (props.formData.mailMergeTemplateId) ? parseInt(props.formData.mailMergeTemplateId) : null,
            SubjectLine: (props.formData.SubjectLine) ? props.formData.SubjectLine : null,
            CallScript: (props.formData.CallScript) ? props.formData.CallScript : null,
        });
    }

    useEffect(() => {
        if (!isEmpty(data)) {
            if ((data.scope === 'create' || data.scope === 'update')
                && data.status === 'success') {

                if (activityPlan.id) {
                    navigate(`/activityPlan/edit/${activityPlan.id}`);
                }
                if (activityPlanId) {
                    navigate(`/activityPlan/edit/${activityPlanId}`);
                }
            }
            if (!isLoaded
                && isMounted
                && (data.scope === 'select' || data.scope === 'new')
                && data.status === 'success'
            ) {

                if (data.body && data.body.id) {
                    if (data.body.executionTypeId === constants.ACTIVITYPLANEXECUTIONTYPE_PERFORMIMMEDIATELY) {
                        data.body.triggerFieldTypeIdImmediate = data.body.triggerFieldTypeId;
                        data.body.fileCompleteStatusIdImmediate = data.body.fileCompleteStatusId;
                    }

                    if (data.body.activityTypeId) {
                        setSelectedTab(activityTypeValues.filter(value => parseInt(value.id) === parseInt(data.body.activityTypeId))[0].alias);
                    }

                    if (data.body.activityPlan) {
                        listPrecedingActivities({ templateId: data.body.id, planId: data.body.activityPlan.id });
                        selectRecordPlan({ activityPlanId: data.body.activityPlan.id });
                    }



                    dispatch(breadcrumbAddRoute({
                        key: 'activityPlan', text: 'Activity Plan', path: {
                            event: () => {
                                navigate('/activityPlan/edit/' + data.body.activityPlan.id);
                            }
                        }
                    }));
                    dispatch(breadcrumbAddRoute({
                        key: 'activityTemplate', text: 'Activity Template', path: {
                            event: () => {
                                navigate('/activityPlan/template/edit/' + data.body.id);
                            }
                        }
                    }));
                }



                setActivityTemplate(data.body);
                setIsLoaded(true);
            }

            if (!isNew
                && (data.scope === 'new'
                    && data.status === 'success')
            ) {
                setIsNew(true);
            }

            if (data.status === 'success') {
                if (data.scope === 'list_securityroles') {
                    setListSecurityRolesData(data.body);
                } else if (data.scope === 'list_businessdaytypes') {
                    setListBusinessDayTypesData(data.body);
                } else if (data.scope === 'list_operators') {
                    setListOperatorsData(data.body);
                } else if (data.scope === 'list_triggeringfields') {
                    setListTriggeringFieldsData(data.body);
                } else if (data.scope === 'list_triggeringimmediatefields') {
                    setListTriggeringImmediateFieldsData(data.body);
                } else if (data.scope === 'list_precedingactivities') {
                    setListPrecedingActivitiesData(data.body);
                } else if (data.scope === 'list_filecompletestatuses') {
                    setListFileCompleteStatusesData(data.body);
                } else if (data.scope === 'list_settlementStatementStatuses') {
                    setListSettlementStatementStatusesData(data.body);
                } else if (data.scope === 'list_severreasons') {
                    setlistSeverReasonsData(data.body);
                } else if (data.scope === 'list_activitytargets') {
                    setListActivityTargetsData(data.body);
                } else if (data.scope === 'list_activityagenttypetargets') {
                    setListActivityAgentTypeTargetsData(data.body);
                } else if (data.scope === 'list_departmentemailactivitytargets') {
                    setListDepartmentEmailActivityTargetsData(data.body);
                } else if (data.scope === 'list_transactionstatustriggers') {
                    setListTransactionStatusTriggerData(data.body);
                } else if (data.scope === 'list_agentstatustriggers') {
                    setListAgentStatusTriggerData(data.body);
                } else if (data.scope === 'list_instancetypes') {
                    setListInstanceTypeData(data.body);
                }
            }

            setIsBusy(
                data.status === 'processing' && (data.scope === 'edit' || data.scope === 'update' || data.scope === 'create')
            );
        }

    }, [
        data,
        activityPlan,
        activityPlanId,
        props,
        isNew,
        addAlert,
        isLoaded,
        isMounted,
        clearData,
        listPrecedingActivities,
        listTriggeringFields,
        listTriggeringImmediateFields,
        listTransactionStatusTriggers,
        listAgentStatusTriggers,
        setListSecurityRolesData,
        setListBusinessDayTypesData,
        setListOperatorsData,
        setListTriggeringFieldsData,
        setListAgentStatusTriggerData,
        setListTriggeringImmediateFieldsData,
        setListPrecedingActivitiesData,
        setListFileCompleteStatusesData,
        setListSettlementStatementStatusesData,
        setlistSeverReasonsData,
        setListTransactionStatusTriggerData,
        setListActivityTargetsData,
        setListActivityAgentTypeTargetsData,
        setListDepartmentEmailActivityTargetsData,
        selectRecordPlan,
        activityTypeValues,
        dispatch

    ]);

    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }

        setTemporaryPlan({
            name: decodeURIComponent(props.name),
            description: decodeURIComponent(props.description),
            categoryId: props.category,
            subCategoryIds: !isEmpty(props.subcategory) ? props.subcategory.split('-') : '',
            startDate: props.startdate,
            endDate: isEmpty(props.enddate) || props.enddate === 'undefined' ? '' : props.enddate
        })

        dispatch(breadcrumbAddRoute({
            key: 'activityPlans', text: 'Activity Plans', path: {
                event: () => {
                    dispatch(breadcrumbRemoveRoute(2));
                    navigate('/activityPlans');
                }
            }
        }));

        if (props.activityPlanId) {
            dispatch(breadcrumbAddRoute({
                key: 'activityPlan', text: 'Activity Plan', path: {
                    event: () => {
                        navigate('/activityPlan/edit/' + props.activityPlanId);
                    }
                }
            }));
            dispatch(breadcrumbAddRoute({
                key: 'activityTemplate', text: 'New Template'
            }));
        }

        setActivityTypeValues([
            {
                "id": 277,
                "name": "To Do",
                "alias": "todo"
            },
            {
                "id": 278,
                "name": "Call",
                "alias": "call"
            },
            {
                "id": 279,
                "name": "Email",
                "alias": "email"
            },
            {
                "id": 280,
                "name": "Sms",
                "alias": "sms"
            },
            {
                "id": 281,
                "name": "Letter",
                "alias": "letter"
            },
            {
                "id": 365,
                "name": "Calendar",
                "alias": "calendar"
            },
        ]);

        if (!isLoadedFull) {
            listSecurityRoles();
            listBusinessDayTypes();
            listOperators();
            listSeverReasons();
            listFileCompleteStatuses();
            listSettlementStatementStatuses();
            listActivityTargets();
            listActivityAgentTypeTargets();
            listDepartmentEmailActivityTargets();
            listAgentStatusTriggers();
            listSeverReasons();
            listInstanceTypes();

            if (!isNaN(props.activityTemplateId)) {
                selectRecord({ activityTemplateId: props.activityTemplateId });
                setIsNew(false);
            } else {
                if (!isEmpty(props.activityPlanId)) {
                    selectRecordPlan({ activityPlanId: props.activityPlanId });
                }
                if (!isEmpty(props.activityPlanId) && props.activityPlanId) {
                    listPrecedingActivities({ templateId: 0, planId: parseInt(props.activityPlanId) });
                }
                if (props.category) {
                    listTriggeringFields({ categoryId: props.category });
                    listTriggeringImmediateFields({ categoryId: props.category });
                    listTransactionStatusTriggers({ categoryId: props.category });
                }

                newRecord();
            }
        }

        setIsMounted(true);
    }, [
        props,
        hasPermission,
        isMounted,
        newRecord,
        selectRecord,
        listSecurityRoles,
        listBusinessDayTypes,
        listOperators,
        listActivityTargets,
        listActivityAgentTypeTargets,
        listDepartmentEmailActivityTargets,
        listPrecedingActivities,
        listTriggeringFields,
        listTriggeringImmediateFields,
        listFileCompleteStatuses,
        listSettlementStatementStatuses,
        listTransactionStatusTriggers,
        listAgentStatusTriggers,
        listSeverReasonsData,
        listInstanceTypes,
        selectRecordPlan,
        isLoadedFull,
        dispatch
    ]);

    useEffect(() => {
        if (!isLoadedFull) {
            if (!isEmpty(listSecurityRolesData)
                && !isEmpty(listBusinessDayTypesData)
                && !isEmpty(listOperatorsData)
                && !isEmpty(listActivityTargetsData)
                && !isEmpty(listFileCompleteStatusesData)
                && !isEmpty(listSettlementStatementStatusesData)
                && !isEmpty(listActivityAgentTypeTargetsData)
                && !isEmpty(listTriggeringFieldsData)
                && !isEmpty(listTriggeringImmediateFieldsData)
                && !isEmpty(listTransactionStatusTriggerData)
                && !isEmpty(listAgentStatusTriggerData)
                && !isEmpty(listSeverReasonsData)
                && !isEmpty(listInstanceTypeData)
            ) {
                if (!isEmpty(activityTemplate) && !isEmpty(activityPlan)) {
                    if ((activityPlan.activityTemplates.length > 1 && !isEmpty(listPrecedingActivitiesData)) || (activityPlan.activityTemplates.length < 2)) {
                        activityTemplate.SelectedListingAgentActivityTargets = (
                            activityTemplate.activityAgentTargets[0] && parseInt(activityTemplate.activityAgentTargets[0].agentSideId) === 2)
                            ? activityTemplate.activityAgentTargets[0].agentId
                            : (
                                (activityTemplate.activityAgentTargets[1] && parseInt(activityTemplate.activityAgentTargets[1].agentSideId) === 2)
                                    ? activityTemplate.activityAgentTargets[1].agentId
                                    : 0
                            );

                        activityTemplate.IsActivityTargetForListingAgents = (
                            activityTemplate.activityAgentTargets[0] && parseInt(activityTemplate.activityAgentTargets[0].agentSideId) === 2)
                            ? true
                            : (
                                (activityTemplate.activityAgentTargets[1] && parseInt(activityTemplate.activityAgentTargets[1].agentSideId) === 2)
                                    ? true
                                    : false
                            );

                        activityTemplate.SelectedSellingAgentActivityTargets = (
                            activityTemplate.activityAgentTargets[0] && parseInt(activityTemplate.activityAgentTargets[0].agentSideId) === 1)
                            ? activityTemplate.activityAgentTargets[0].agentId
                            : (
                                (activityTemplate.activityAgentTargets[1] && parseInt(activityTemplate.activityAgentTargets[1].agentSideId) === 1)
                                    ? activityTemplate.activityAgentTargets[1].agentId
                                    : 0
                            );

                        activityTemplate.IsActivityTargetForSellingAgents = (
                            activityTemplate.activityAgentTargets[0] && parseInt(activityTemplate.activityAgentTargets[0].agentSideId) === 1)
                            ? true
                            : (
                                (activityTemplate.activityAgentTargets[1] && parseInt(activityTemplate.activityAgentTargets[1].agentSideId) === 1)
                                    ? true
                                    : false
                            );

                        let statuses = activityTemplate.activityTransactionStatuses.map(selection => {
                            return {
                                id: selection.transactionStatusTypeId,
                                isReadonly: false,
                                name: selection.transactionStatusType.name
                            }
                        });
                        activityTemplate.selectedTransactionStatusIds = statuses;
                        setSelectedTransactionStatusTriggerOptions(statuses);


                        activityTemplate.IsActivityTargetForSellers = 0;
                        activityTemplate.IsActivityTargetForBuyers = 0;
                        activityTemplate.IsActivityTargetForListingInhouseTransactionCoordinator = 0;
                        activityTemplate.IsActivityTargetForSellingInhouseTransactionCoordinator = 0;
                        activityTemplate.IsActivityTargetForListingSideBranchManagers = 0;
                        activityTemplate.IsActivityTargetForSellingSideBranchManagers = 0;
                        setIsDepartmentEmailActivityTarget(false);
                        activityTemplate.activityTargets.forEach((activityTarget) => {
                            const targetId = parseInt(activityTarget.activityTargetId);
                            if (targetId === sellersActivityTargetType) {
                                activityTemplate.IsActivityTargetForSellers = 1;
                            } else if (targetId === buyersActivityTargetType) {
                                activityTemplate.IsActivityTargetForBuyers = 1;
                            } else if (targetId === listingInhouseActivityTargetType) {
                                activityTemplate.IsActivityTargetForListingInhouseTransactionCoordinator = 1;
                            } else if (targetId === sellingInhouseActivityTargetType) {
                                activityTemplate.IsActivityTargetForSellingInhouseTransactionCoordinator = 1;
                            } else if (targetId === listingBranchManagerActivityTargetType) {
                                activityTemplate.IsActivityTargetForListingSideBranchManagers = 1;
                            } else if (targetId === sellingBranchManagerActivityTargetType) {
                                activityTemplate.IsActivityTargetForSellingSideBranchManagers = 1;
                            } else if (targetId >= constants.DepartmentEmailActivityTargetTypeEnum.AgentServicesDepartmentEmail && targetId <= constants.DepartmentEmailActivityTargetTypeEnum.MentorshipDepartmentEmail) {
                                activityTemplate.SelectedDepartmentEmailActivityTarget = targetId;
                                setIsDepartmentEmailActivityTarget(true);
                            }
                        });

                        props.formInitialize(activityTemplate);
                        setAssignToTrigger((activityTemplate.isOptional) ? 'IsOptional' : 'IsAutomaticTrigger')
                        setIsLoadedFull(true);

                        if (activityTemplate.IsActivityTargetForListingAgents === true || activityTemplate.IsActivityTargetForListingAgents === 1) {
                            setIsListingAgents(true);
                        }
                        if (activityTemplate.IsActivityTargetForSellingAgents === true || activityTemplate.IsActivityTargetForSellingAgents === 1) {
                            setIsSellingAgents(true);
                        }
                        if (activityTemplate.IsActivityTargetForSellers === true || activityTemplate.IsActivityTargetForSellers === 1) {
                            setIsSellers(true);
                        }
                        if (activityTemplate.IsActivityTargetForBuyers === true || activityTemplate.IsActivityTargetForBuyers === 1) {
                            setIsBuyers(true);
                        }
                        if (activityTemplate.IsActivityTargetForListingInhouseTransactionCoordinator === true || activityTemplate.IsActivityTargetForListingInhouseTransactionCoordinator === 1) {
                            setIsListingInhouseTransactionCoordinator(true);
                        }
                        if (activityTemplate.IsActivityTargetForSellingInhouseTransactionCoordinator === true || activityTemplate.IsActivityTargetForSellingInhouseTransactionCoordinator === 1) {
                            setIsSellingInhouseTransactionCoordinator(true);
                        }
                        if (activityTemplate.IsActivityTargetForListingSideBranchManagers === true || activityTemplate.IsActivityTargetForListingSideBranchManagers === 1) {
                            setIsListingSideBranchManager(true);
                        }
                        if (activityTemplate.IsActivityTargetForSellingSideBranchManagers === true || activityTemplate.IsActivityTargetForSellingSideBranchManagers === 1) {
                            setIsSellingSideBranchManager(true);
                        }
                    }
                } else if (isNew) {
                    props.formInitialize(activityTemplate);
                    setIsLoadedFull(true);
                }
            }
        }
    }, [
        isNew,
        props,
        isLoadedFull,
        activityTemplate,
        activityPlan,
        listSecurityRolesData,
        listBusinessDayTypesData,
        listOperatorsData,
        listActivityTargetsData,
        listActivityAgentTypeTargetsData,
        listTriggeringFieldsData,
        listTriggeringImmediateFieldsData,
        listPrecedingActivities,
        listPrecedingActivitiesData,
        listFileCompleteStatusesData,
        listSettlementStatementStatusesData,
        listSeverReasonsData,
        listTransactionStatusTriggerData,
        listAgentStatusTriggerData,
        listInstanceTypeData
    ]);

    useEffect(() => {
        if (!isEmpty(dataPlan)) {
            if (!isLoadedPlan && isMounted) {
                if (dataPlan.scope === 'create' && dataPlan.status === 'success') {
                    setActivityPlanId(dataPlan.body.id);
                    setIsLoadedPlan(true);
                    savePlanTemplate(dataPlan.body.id);
                    let addingPlanAvailable = dataPlan?.body?.activityTemplates?.some(x => x.id != props.activityTemplateId && !x.isDeleted && Object.values(constants.ACTIVITYPLAN_ADDINGPLAN_ENUM).includes(x.triggerFieldTypeId)) || false;
                    setIsDisableAddingPlan(addingPlanAvailable);
                }

                if ((dataPlan.scope === 'select' || dataPlan.scope === 'new')
                    && dataPlan.status === 'success') {
                    if (dataPlan.body && dataPlan.body.id) {
                        setActivityPlan(dataPlan.body);
                        let addingPlanAvailable = dataPlan?.body?.activityTemplates?.some(x => x.id != props.activityTemplateId && !x.isDeleted && Object.values(constants.ACTIVITYPLAN_ADDINGPLAN_ENUM).includes(x.triggerFieldTypeId)) || false;
                        setIsDisableAddingPlan(addingPlanAvailable);

                        dispatch(breadcrumbAddRoute({
                            key: 'activityPlan', text: 'Activity Plan', path: {
                                event: () => {
                                    navigate('/activityPlan/edit/' + dataPlan.body.id);
                                }
                            }
                        }));
                    }

                    setIsLoadedPlan(true);
                }

                setIsBusy(
                    dataPlan.status === 'processing' && (dataPlan.scope === 'edit' || dataPlan.scope === 'update' || dataPlan.scope === 'create')
                );
            }
        }

    }, [
        dataPlan,
        listTriggeringFields,
        listTriggeringImmediateFieldsData,
        listTransactionStatusTriggerData,
        listPrecedingActivities,
        dispatch,
        isLoadedPlan,
        isMounted
    ]);

    useEffect(() => {
        if (!isEmpty(listSecurityRolesData)) {
            const categoryOptions = listSecurityRolesData && listSecurityRolesData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListSecurityRolesOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        }
    }, [listSecurityRolesData]);

    useEffect(() => {
        if (!isEmpty(listInstanceTypeData)) {
            const categoryOptions = listInstanceTypeData && listInstanceTypeData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListInstanceTypeOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        }
    }, [listInstanceTypeData]);

    useEffect(() => {
        if (!isEmpty(listBusinessDayTypesData)) {
            const categoryOptions = listBusinessDayTypesData && listBusinessDayTypesData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListBusinessDayTypesOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        }
    }, [listBusinessDayTypesData]);

    useEffect(() => {
        if (!isEmpty(listOperatorsData)) {
            const categoryOptions = listOperatorsData && listOperatorsData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListOperatorsOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        }
    }, [listOperatorsData]);

    useEffect(() => {
        if (!isEmpty(listTriggeringFieldsData)) {
            const categoryOptions = listTriggeringFieldsData && listTriggeringFieldsData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListTriggeringFieldsOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        }
    }, [listTriggeringFieldsData]);

    useEffect(() => {
        if (!isEmpty(listAgentStatusTriggerData)) {
            const categoryOptions = listAgentStatusTriggerData && listAgentStatusTriggerData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListAgentStatusTriggerOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        }
    }, [listAgentStatusTriggerData]);

    useEffect(() => {
        if (!isEmpty(listTriggeringImmediateFieldsData)) {
            const categoryOptions = listTriggeringImmediateFieldsData && listTriggeringImmediateFieldsData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListTriggeringImmediateFieldsOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        }
    }, [listTriggeringImmediateFieldsData]);

    useEffect(() => {
        if (!isEmpty(listPrecedingActivitiesData)) {
            const categoryOptions = listPrecedingActivitiesData && listPrecedingActivitiesData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListPrecedingActivitiesOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        } else {
            setListPrecedingActivitiesOptions([]);
        }
    }, [listPrecedingActivitiesData]);

    useEffect(() => {
        if (!isEmpty(listFileCompleteStatusesData)) {
            const categoryOptions = listFileCompleteStatusesData && listFileCompleteStatusesData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListFileCompleteStatusesOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: false }));
        } else {
            setListFileCompleteStatusesOptions([]);
        }
    }, [listFileCompleteStatusesData]);

    useEffect(() => {
        if (!isEmpty(listSettlementStatementStatusesData)) {
            const categoryOptions = listSettlementStatementStatusesData && listSettlementStatementStatusesData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListSettlementStatementStatusesOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: false }));
        } else {
            setListSettlementStatementStatusesOptions([]);
        }
    }, [listSettlementStatementStatusesData]);

    useEffect(() => {
        if (!isEmpty(listActivityTargetsData)) {
            const categoryOptions = listActivityTargetsData && listActivityTargetsData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListActivityTargetsOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        }
    }, [listActivityTargetsData]);

    useEffect(() => {
        if (!isEmpty(listActivityAgentTypeTargetsData)) {
            const categoryOptions = listActivityAgentTypeTargetsData && listActivityAgentTypeTargetsData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListActivityAgentTypeTargetsOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        }
    }, [listActivityAgentTypeTargetsData]);

    useEffect(() => {
        if (!isEmpty(listDepartmentEmailActivityTargetsData)) {
            const categoryOptions = listDepartmentEmailActivityTargetsData && listDepartmentEmailActivityTargetsData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListDepartmentEmailActivityTargetsOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Select...' }));
        }
    }, [listDepartmentEmailActivityTargetsData]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    useEffect(() => {
        if (props.formClosing === true) {
            if (activityPlan.id) {
                navigate(`/activityPlan/edit/${activityPlan.id}`);
            } else {
                navigate(`/activityPlan/new`);
            }
        }
    }, [props.formClosing, activityPlan]);

    useEffect(() => {
        if (activityPlan.categoryId) {
            listTriggeringFields({ categoryId: activityPlan.categoryId });
            listTriggeringImmediateFields({ categoryId: activityPlan.categoryId });
            listTransactionStatusTriggers({ categoryId: activityPlan.categoryId });
        }
    }, [activityPlan]);

    useEffect(() => {
        if ((
            temporaryPlan
            && temporaryPlan.categoryId
            && parseInt(temporaryPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_AGENT
        ) || (
                activityPlan
                && activityPlan.categoryId
                && parseInt(activityPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_AGENT
            )) {
            setIsAgentCategory(true);
        }
        if ((
            temporaryPlan
            && temporaryPlan.categoryId
            && parseInt(temporaryPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_RENTAL
        ) || (
                activityPlan
                && activityPlan.categoryId
                && parseInt(activityPlan.categoryId) === constants.ACTIVITYPLANCATEGORY_RENTAL
            )) {
            setIsRentalCategory(true);
        }
    }, [activityPlan, temporaryPlan]);

    return (
        <>
            <SideMenu activeKey="content" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
                {hasPermission && isLoadedFull
                    ?
                    <Suspense fallback={<Spinner text="Loading Activity Template..." />}>
                        {
                            <div style={{ paddingRight: '15px' }}>
                                {!isNew &&
                                    <PageHeader title={"Edit Activity Template: " + props.formData['name']} />
                                }
                                {isNew &&
                                    <PageHeader title={"New Activity Template"} />
                                }
                                <ConfirmationModal
                                    show={showTabChangeModal}
                                    noClicked={tabSelectedNoHandler}
                                    yesClicked={tabSelectedYesHandler}
                                    yesText='Switch activity type'
                                    noText='Cancel'>
                                    <p>Switching the activity type will remove any data you have entered</p>
                                </ConfirmationModal>

                                <Panel>
                                    <Panel.Body>
                                        <Form>
                                            <Row>
                                                <div className="col-md-12">
                                                    <Tab.Container defaultActiveKey="general" id="templateTabs" activeKey={selectedTab} onSelect={tabSelectedHandler}>
                                                        <Row className="clearfix">
                                                            <Col sm={12}>
                                                                {
                                                                    activityTemplate?.id ?
                                                                        <Nav bsStyle="pills">
                                                                            {selectedTab === 'todo' && <NavItem eventKey="todo" disabled={isBusy}>To Do</NavItem>}
                                                                            {selectedTab === 'call' && <NavItem eventKey="call" disabled={isBusy}>Call</NavItem>}
                                                                            {selectedTab === 'email' && <NavItem eventKey="email" disabled={isBusy}>Email</NavItem>}
                                                                            {selectedTab === 'sms' && <NavItem eventKey="sms" disabled={isBusy}>SMS</NavItem>}
                                                                            {selectedTab === 'letter' && <NavItem eventKey="letter" disabled={isBusy}>Letter</NavItem>}
                                                                            {selectedTab === 'calendar' && <NavItem eventKey="calendar" disabled={isBusy}>Calendar</NavItem>}
                                                                        </Nav>
                                                                        :
                                                                        <Nav bsStyle="pills">
                                                                            <NavItem eventKey="todo" disabled={isBusy}>To Do</NavItem>
                                                                            <NavItem eventKey="call" disabled={isBusy}>Call</NavItem>
                                                                            <NavItem eventKey="email" disabled={isBusy}>Email</NavItem>
                                                                            <NavItem eventKey="sms" disabled={isBusy}>SMS</NavItem>
                                                                            <NavItem eventKey="letter" disabled={isBusy}>Letter</NavItem>
                                                                            <NavItem eventKey="calendar" disabled={isBusy}>Calendar</NavItem>
                                                                        </Nav>
                                                                }
                                                            </Col>
                                                            <Col sm={12}>
                                                                <Tab.Content animation>
                                                                    {(!activityTemplate || (activityTemplate?.id && selectedTab === 'todo')) &&
                                                                        <Tab.Pane eventKey="todo">
                                                                            <Instance
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listInstanceTypeOptions={listInstanceTypeOptions}
                                                                            />
                                                                            <Name
                                                                                formProps={props}
                                                                                assignToTrigger={assignToTrigger}
                                                                                isBusy={isBusy}
                                                                                templateName={templateName}
                                                                                setTemplateName={setTemplateName}
                                                                                tab='todo'
                                                                            />
                                                                            <AssignTo
                                                                                tab='todo'
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listSecurityRolesOptions={listSecurityRolesOptions}
                                                                                setAssignToTrigger={setAssignToTrigger}
                                                                                assignToTrigger={assignToTrigger}
                                                                            />
                                                                            {
                                                                                !isAgentCategory &&
                                                                                <ActivityFor
                                                                                    tab='todo'
                                                                                    activityPlan={activityPlan}
                                                                                    formProps={props}
                                                                                    isBusy={isBusy}
                                                                                    listActivityTargetsOptions={listActivityTargetsOptions}
                                                                                    listActivityAgentTypeTargetsOptions={listActivityAgentTypeTargetsOptions}
                                                                                    isListingAgents={isListingAgents}
                                                                                    setIsListingAgents={setIsListingAgents}
                                                                                    isSellingAgents={isSellingAgents}
                                                                                    setIsSellingAgents={setIsSellingAgents}
                                                                                    setIsSellers={setIsSellers}
                                                                                    setIsBuyers={setIsBuyers}
                                                                                    setIsListingInhouseTransactionCoordinator={setIsListingInhouseTransactionCoordinator}
                                                                                    setIsSellingInhouseTransactionCoordinator={setIsSellingInhouseTransactionCoordinator}
                                                                                    setIsListingSideBranchManagers={setIsListingSideBranchManager}
                                                                                    setIsSellingSideBranchManagers={setIsSellingSideBranchManager}
                                                                                />
                                                                            }

                                                                            <PerformActivity
                                                                                tab='todo'
                                                                                activityPlan={activityPlan}
                                                                                temporaryPlan={temporaryPlan}
                                                                                formProps={props}
                                                                                assignToTrigger={assignToTrigger}
                                                                                isBusy={isBusy}
                                                                                listPrecedingActivitiesOptions={listPrecedingActivitiesOptions}
                                                                                listTriggeringFieldsOptions={listTriggeringFieldsOptions}
                                                                                listTriggeringImmediateFieldsOptions={listTriggeringImmediateFieldsOptions}
                                                                                listFileCompleteStatusesOptions={listFileCompleteStatusesOptions}
                                                                                listSettlementStatementStatusOptions={listSettlementStatementStatusOptions}
                                                                                listSeverReasonsData={listSeverReasonsData}
                                                                                listTransactionStatusTriggerData={listTransactionStatusTriggerData}
                                                                                listOperatorsOptions={listOperatorsOptions}
                                                                                listAgentStatusTriggerOptions={listAgentStatusTriggerOptions}
                                                                                selectedTransactionStatusTriggerOptions={selectedTransactionStatusTriggerOptions}
                                                                                setSelectedTransactionStatusTriggerOptions={setSelectedTransactionStatusTriggerOptions}
                                                                                setRadioPerformSelected={setRadioPerformSelected}
                                                                                radioPerformSelected={radioPerformSelected}
                                                                                setTriggerFieldTypeId={setTriggerFieldTypeId}
                                                                                setTriggerFieldTypeIdImmediate={setTriggerFieldTypeIdImmediate}
                                                                                triggerFieldTypeId={triggerFieldTypeId}
                                                                                triggerFieldTypeIdImmediate={triggerFieldTypeIdImmediate}
                                                                                recurringTriggerIds={recurringTriggerIds}
                                                                            />
                                                                            <AlternateDays
                                                                                tab={selectedTab}
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listBusinessDayTypesOptions={listBusinessDayTypesOptions}
                                                                            />
                                                                            <Reminder
                                                                                tab={selectedTab}
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                assignToTrigger={assignToTrigger}
                                                                            />

                                                                        </Tab.Pane>
                                                                    }
                                                                    {(!activityTemplate || (activityTemplate?.id && selectedTab === 'call')) &&

                                                                        <Tab.Pane eventKey="call">
                                                                            <Instance
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listInstanceTypeOptions={listInstanceTypeOptions}
                                                                            />
                                                                            <Name
                                                                                formProps={props}
                                                                                assignToTrigger={assignToTrigger}
                                                                                isBusy={isBusy}
                                                                                templateName={templateName}
                                                                                setTemplateName={setTemplateName}
                                                                                tab='call'
                                                                            />
                                                                            <AssignTo
                                                                                tab='call'
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listSecurityRolesOptions={listSecurityRolesOptions}
                                                                                setAssignToTrigger={setAssignToTrigger}
                                                                                assignToTrigger={assignToTrigger}
                                                                            />
                                                                            <CallScript
                                                                                tab='call'
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                temporaryPlan={temporaryPlan}
                                                                            />
                                                                            {
                                                                                !isAgentCategory &&
                                                                                <ActivityFor
                                                                                    tab='call'
                                                                                    activityPlan={activityPlan}
                                                                                    formProps={props}
                                                                                    isBusy={isBusy}
                                                                                    listActivityTargetsOptions={listActivityTargetsOptions}
                                                                                    listActivityAgentTypeTargetsOptions={listActivityAgentTypeTargetsOptions}
                                                                                    isListingAgents={isListingAgents}
                                                                                    setIsListingAgents={setIsListingAgents}
                                                                                    isSellingAgents={isSellingAgents}
                                                                                    setIsSellingAgents={setIsSellingAgents}
                                                                                    setIsSellers={setIsSellers}
                                                                                    setIsBuyers={setIsBuyers}
                                                                                    setIsListingInhouseTransactionCoordinator={setIsListingInhouseTransactionCoordinator}
                                                                                    setIsSellingInhouseTransactionCoordinator={setIsSellingInhouseTransactionCoordinator}
                                                                                    setIsListingSideBranchManagers={setIsListingSideBranchManager}
                                                                                    setIsSellingSideBranchManagers={setIsSellingSideBranchManager}
                                                                                />
                                                                            }

                                                                            <PerformActivity
                                                                                tab='call'
                                                                                activityPlan={activityPlan}
                                                                                temporaryPlan={temporaryPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                assignToTrigger={assignToTrigger}
                                                                                listPrecedingActivitiesOptions={listPrecedingActivitiesOptions}
                                                                                listTriggeringFieldsOptions={listTriggeringFieldsOptions}
                                                                                listTriggeringImmediateFieldsOptions={listTriggeringImmediateFieldsOptions}
                                                                                listFileCompleteStatusesOptions={listFileCompleteStatusesOptions}
                                                                                listSettlementStatementStatusOptions={listSettlementStatementStatusOptions}
                                                                                listSeverReasonsData={listSeverReasonsData}
                                                                                listTransactionStatusTriggerData={listTransactionStatusTriggerData}
                                                                                listOperatorsOptions={listOperatorsOptions}
                                                                                listAgentStatusTriggerOptions={listAgentStatusTriggerOptions}
                                                                                selectedTransactionStatusTriggerOptions={selectedTransactionStatusTriggerOptions}
                                                                                setSelectedTransactionStatusTriggerOptions={setSelectedTransactionStatusTriggerOptions}
                                                                                setRadioPerformSelected={setRadioPerformSelected}
                                                                                radioPerformSelected={radioPerformSelected}
                                                                                setTriggerFieldTypeId={setTriggerFieldTypeId}
                                                                                setTriggerFieldTypeIdImmediate={setTriggerFieldTypeIdImmediate}
                                                                                triggerFieldTypeId={triggerFieldTypeId}
                                                                                triggerFieldTypeIdImmediate={triggerFieldTypeIdImmediate}
                                                                                recurringTriggerIds={recurringTriggerIds}
                                                                            />
                                                                            <AlternateDays
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listBusinessDayTypesOptions={listBusinessDayTypesOptions}
                                                                            />
                                                                            <Reminder
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                assignToTrigger={assignToTrigger}
                                                                            />
                                                                        </Tab.Pane>
                                                                    }
                                                                    {(!activityTemplate || (activityTemplate?.id && selectedTab === 'email')) &&

                                                                        <Tab.Pane eventKey="email">
                                                                            <Instance
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listInstanceTypeOptions={listInstanceTypeOptions}
                                                                            />
                                                                            <Name
                                                                                formProps={props}
                                                                                assignToTrigger={assignToTrigger}
                                                                                isBusy={isBusy}
                                                                                templateName={templateName}
                                                                                setTemplateName={setTemplateName}
                                                                                tab='email'
                                                                            />
                                                                            <EmailTemplate
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                temporaryPlan={temporaryPlan}
                                                                                canEdit={canEdit}
                                                                            />
                                                                            <AssignTo
                                                                                tab='email'
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listSecurityRolesOptions={listSecurityRolesOptions}
                                                                                setAssignToTrigger={setAssignToTrigger}
                                                                                assignToTrigger={assignToTrigger}
                                                                            />
                                                                            {
                                                                                !isAgentCategory &&
                                                                                <ActivityFor
                                                                                    tab='email'
                                                                                    activityPlan={activityPlan}
                                                                                    formProps={props}
                                                                                    isBusy={isBusy}
                                                                                    listActivityTargetsOptions={listActivityTargetsOptions}
                                                                                    listActivityAgentTypeTargetsOptions={listActivityAgentTypeTargetsOptions}
                                                                                    isListingAgents={isListingAgents}
                                                                                    setIsListingAgents={setIsListingAgents}
                                                                                    isSellingAgents={isSellingAgents}
                                                                                    setIsSellingAgents={setIsSellingAgents}
                                                                                    setIsSellers={setIsSellers}
                                                                                    setIsBuyers={setIsBuyers}
                                                                                    setIsListingInhouseTransactionCoordinator={setIsListingInhouseTransactionCoordinator}
                                                                                    setIsSellingInhouseTransactionCoordinator={setIsSellingInhouseTransactionCoordinator}
                                                                                    setIsListingSideBranchManagers={setIsListingSideBranchManager}
                                                                                    setIsSellingSideBranchManagers={setIsSellingSideBranchManager}
                                                                                    listDepartmentEmailActivityTargetsOptions={listDepartmentEmailActivityTargetsOptions}
                                                                                    isDepartmentEmailActivityTarget={isDepartmentEmailActivityTarget}
                                                                                    setIsDepartmentEmailActivityTarget={setIsDepartmentEmailActivityTarget}
                                                                                />
                                                                            }
                                                                            <PerformActivity
                                                                                tab='email'
                                                                                activityPlan={activityPlan}
                                                                                temporaryPlan={temporaryPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listPrecedingActivitiesOptions={listPrecedingActivitiesOptions}
                                                                                listTriggeringFieldsOptions={listTriggeringFieldsOptions}
                                                                                listTriggeringImmediateFieldsOptions={listTriggeringImmediateFieldsOptions}
                                                                                listFileCompleteStatusesOptions={listFileCompleteStatusesOptions}
                                                                                listSettlementStatementStatusOptions={listSettlementStatementStatusOptions}
                                                                                listSeverReasonsData={listSeverReasonsData}
                                                                                listTransactionStatusTriggerData={listTransactionStatusTriggerData}
                                                                                listOperatorsOptions={listOperatorsOptions}
                                                                                listAgentStatusTriggerOptions={listAgentStatusTriggerOptions}
                                                                                assignToTrigger={assignToTrigger}
                                                                                selectedTransactionStatusTriggerOptions={selectedTransactionStatusTriggerOptions}
                                                                                setSelectedTransactionStatusTriggerOptions={setSelectedTransactionStatusTriggerOptions}
                                                                                setRadioPerformSelected={setRadioPerformSelected}
                                                                                radioPerformSelected={radioPerformSelected}
                                                                                setTriggerFieldTypeId={setTriggerFieldTypeId}
                                                                                setTriggerFieldTypeIdImmediate={setTriggerFieldTypeIdImmediate}
                                                                                triggerFieldTypeId={triggerFieldTypeId}
                                                                                triggerFieldTypeIdImmediate={triggerFieldTypeIdImmediate}
                                                                                recurringTriggerIds={recurringTriggerIds}
                                                                                isDisableAddingPlan={isDisableAddingPlan}
                                                                            />
                                                                            <AlternateDays
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listBusinessDayTypesOptions={listBusinessDayTypesOptions}
                                                                            />
                                                                            <Reminder
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                assignToTrigger={assignToTrigger}
                                                                            />
                                                                        </Tab.Pane>
                                                                    }
                                                                    {(!activityTemplate || (activityTemplate?.id && selectedTab === 'sms')) &&

                                                                        <Tab.Pane eventKey="sms">
                                                                            <Instance
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listInstanceTypeOptions={listInstanceTypeOptions}
                                                                            />
                                                                            <Name
                                                                                formProps={props}
                                                                                assignToTrigger={assignToTrigger}
                                                                                isBusy={isBusy}
                                                                                templateName={templateName}
                                                                                setTemplateName={setTemplateName}
                                                                                tab='sms'
                                                                            />
                                                                            <SmsTemplate
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                temporaryPlan={temporaryPlan}
                                                                                canEdit={canEdit}
                                                                            />
                                                                            <AssignTo
                                                                                tab='sms'
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listSecurityRolesOptions={listSecurityRolesOptions}
                                                                                setAssignToTrigger={setAssignToTrigger}
                                                                                assignToTrigger={assignToTrigger}
                                                                            />
                                                                            {
                                                                                !isAgentCategory &&
                                                                                <ActivityFor
                                                                                    tab='sms'
                                                                                    activityPlan={activityPlan}
                                                                                    formProps={props}
                                                                                    isBusy={isBusy}
                                                                                    listActivityTargetsOptions={listActivityTargetsOptions}
                                                                                    listActivityAgentTypeTargetsOptions={listActivityAgentTypeTargetsOptions}
                                                                                    isListingAgents={isListingAgents}
                                                                                    setIsListingAgents={setIsListingAgents}
                                                                                    isSellingAgents={isSellingAgents}
                                                                                    setIsSellingAgents={setIsSellingAgents}
                                                                                    setIsSellers={setIsSellers}
                                                                                    setIsBuyers={setIsBuyers}
                                                                                    setIsListingInhouseTransactionCoordinator={setIsListingInhouseTransactionCoordinator}
                                                                                    setIsSellingInhouseTransactionCoordinator={setIsSellingInhouseTransactionCoordinator}
                                                                                    setIsListingSideBranchManagers={setIsListingSideBranchManager}
                                                                                    setIsSellingSideBranchManagers={setIsSellingSideBranchManager}
                                                                                />
                                                                            }
                                                                            <PerformActivity
                                                                                tab='sms'
                                                                                activityPlan={activityPlan}
                                                                                temporaryPlan={temporaryPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listPrecedingActivitiesOptions={listPrecedingActivitiesOptions}
                                                                                listTriggeringFieldsOptions={listTriggeringFieldsOptions}
                                                                                listTriggeringImmediateFieldsOptions={listTriggeringImmediateFieldsOptions}
                                                                                listFileCompleteStatusesOptions={listFileCompleteStatusesOptions}
                                                                                listSettlementStatementStatusOptions={listSettlementStatementStatusOptions}
                                                                                listSeverReasonsData={listSeverReasonsData}
                                                                                listTransactionStatusTriggerData={listTransactionStatusTriggerData}
                                                                                listOperatorsOptions={listOperatorsOptions}
                                                                                listAgentStatusTriggerOptions={listAgentStatusTriggerOptions}
                                                                                assignToTrigger={assignToTrigger}
                                                                                selectedTransactionStatusTriggerOptions={selectedTransactionStatusTriggerOptions}
                                                                                setSelectedTransactionStatusTriggerOptions={setSelectedTransactionStatusTriggerOptions}
                                                                                setRadioPerformSelected={setRadioPerformSelected}
                                                                                radioPerformSelected={radioPerformSelected}
                                                                                setTriggerFieldTypeId={setTriggerFieldTypeId}
                                                                                setTriggerFieldTypeIdImmediate={setTriggerFieldTypeIdImmediate}
                                                                                triggerFieldTypeId={triggerFieldTypeId}
                                                                                triggerFieldTypeIdImmediate={triggerFieldTypeIdImmediate}
                                                                                recurringTriggerIds={recurringTriggerIds}
                                                                                isDisableAddingPlan={isDisableAddingPlan}
                                                                            />
                                                                            <AlternateDays
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listBusinessDayTypesOptions={listBusinessDayTypesOptions}
                                                                            />
                                                                            <Reminder
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                assignToTrigger={assignToTrigger}
                                                                            />
                                                                        </Tab.Pane>
                                                                    }
                                                                    {(!activityTemplate || (activityTemplate?.id && selectedTab === 'letter')) &&

                                                                        <Tab.Pane eventKey="letter">
                                                                            <Instance
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listInstanceTypeOptions={listInstanceTypeOptions}
                                                                            />
                                                                            <Name
                                                                                formProps={props}
                                                                                assignToTrigger={assignToTrigger}
                                                                                isBusy={isBusy}
                                                                                templateName={templateName}
                                                                                setTemplateName={setTemplateName}
                                                                                tab='letter'
                                                                            />
                                                                            <LetterTemplate
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                temporaryPlan={temporaryPlan}
                                                                                canEdit={canEdit}
                                                                            />
                                                                            <AssignTo
                                                                                tab='letter'
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listSecurityRolesOptions={listSecurityRolesOptions}
                                                                                setAssignToTrigger={setAssignToTrigger}
                                                                                assignToTrigger={assignToTrigger}
                                                                            />
                                                                            {
                                                                                !isAgentCategory &&
                                                                                <ActivityFor
                                                                                    tab='letter'
                                                                                    activityPlan={activityPlan}
                                                                                    formProps={props}
                                                                                    isBusy={isBusy}
                                                                                    listActivityTargetsOptions={listActivityTargetsOptions}
                                                                                    listActivityAgentTypeTargetsOptions={listActivityAgentTypeTargetsOptions}
                                                                                    isListingAgents={isListingAgents}
                                                                                    setIsListingAgents={setIsListingAgents}
                                                                                    isSellingAgents={isSellingAgents}
                                                                                    setIsSellingAgents={setIsSellingAgents}
                                                                                    setIsSellers={setIsSellers}
                                                                                    setIsBuyers={setIsBuyers}
                                                                                    setIsListingInhouseTransactionCoordinator={setIsListingInhouseTransactionCoordinator}
                                                                                    setIsSellingInhouseTransactionCoordinator={setIsSellingInhouseTransactionCoordinator}
                                                                                    setIsListingSideBranchManagers={setIsListingSideBranchManager}
                                                                                    setIsSellingSideBranchManagers={setIsSellingSideBranchManager}
                                                                                />
                                                                            }
                                                                            <PerformActivity
                                                                                tab='letter'
                                                                                activityPlan={activityPlan}
                                                                                temporaryPlan={temporaryPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listPrecedingActivitiesOptions={listPrecedingActivitiesOptions}
                                                                                listTriggeringFieldsOptions={listTriggeringFieldsOptions}
                                                                                listTriggeringImmediateFieldsOptions={listTriggeringImmediateFieldsOptions}
                                                                                listFileCompleteStatusesOptions={listFileCompleteStatusesOptions}
                                                                                listSettlementStatementStatusOptions={listSettlementStatementStatusOptions}
                                                                                listSeverReasonsData={listSeverReasonsData}
                                                                                listTransactionStatusTriggerData={listTransactionStatusTriggerData}
                                                                                listOperatorsOptions={listOperatorsOptions}
                                                                                listAgentStatusTriggerOptions={listAgentStatusTriggerOptions}
                                                                                assignToTrigger={assignToTrigger}
                                                                                selectedTransactionStatusTriggerOptions={selectedTransactionStatusTriggerOptions}
                                                                                setSelectedTransactionStatusTriggerOptions={setSelectedTransactionStatusTriggerOptions}
                                                                                setRadioPerformSelected={setRadioPerformSelected}
                                                                                radioPerformSelected={radioPerformSelected}
                                                                                setTriggerFieldTypeId={setTriggerFieldTypeId}
                                                                                setTriggerFieldTypeIdImmediate={setTriggerFieldTypeIdImmediate}
                                                                                triggerFieldTypeId={triggerFieldTypeId}
                                                                                triggerFieldTypeIdImmediate={triggerFieldTypeIdImmediate}
                                                                                recurringTriggerIds={recurringTriggerIds}
                                                                            />
                                                                            <AlternateDays
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                listBusinessDayTypesOptions={listBusinessDayTypesOptions}
                                                                            />
                                                                            <Reminder
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                assignToTrigger={assignToTrigger}
                                                                            />
                                                                        </Tab.Pane>
                                                                    }
                                                                    {(!activityTemplate || (activityTemplate?.id && selectedTab === 'calendar')) &&

                                                                        <Tab.Pane eventKey="calendar">
                                                                            <Name
                                                                                formProps={props}
                                                                                assignToTrigger={assignToTrigger}
                                                                                isBusy={isBusy}
                                                                                templateName={templateName}
                                                                                setTemplateName={setTemplateName}
                                                                                tab='calendar'
                                                                            />
                                                                            <CallScript
                                                                                tab='calendar'
                                                                                activityPlan={activityPlan}
                                                                                formProps={props}
                                                                                isBusy={isBusy}
                                                                                temporaryPlan={temporaryPlan}
                                                                            />
                                                                            {
                                                                                !isAgentCategory &&
                                                                                <ActivityFor
                                                                                    tab='calendar'
                                                                                    activityPlan={activityPlan}
                                                                                    formProps={props}
                                                                                    isBusy={isBusy}
                                                                                    listActivityTargetsOptions={listActivityTargetsOptions}
                                                                                    listActivityAgentTypeTargetsOptions={listActivityAgentTypeTargetsOptions}
                                                                                    isListingAgents={isListingAgents}
                                                                                    setIsListingAgents={setIsListingAgents}
                                                                                    isSellingAgents={isSellingAgents}
                                                                                    setIsSellingAgents={setIsSellingAgents}
                                                                                    setIsSellers={setIsSellers}
                                                                                    setIsBuyers={setIsBuyers}
                                                                                    setIsListingInhouseTransactionCoordinator={setIsListingInhouseTransactionCoordinator}
                                                                                    setIsSellingInhouseTransactionCoordinator={setIsSellingInhouseTransactionCoordinator}
                                                                                    setIsListingSideBranchManagers={setIsListingSideBranchManager}
                                                                                    setIsSellingSideBranchManagers={setIsSellingSideBranchManager}
                                                                                />
                                                                            }

                                                                            <PerformActivity
                                                                                tab='calendar'
                                                                                activityPlan={activityPlan}
                                                                                temporaryPlan={temporaryPlan}
                                                                                formProps={props}
                                                                                assignToTrigger={assignToTrigger}
                                                                                isBusy={isBusy}
                                                                                listPrecedingActivitiesOptions={listPrecedingActivitiesOptions}
                                                                                listTriggeringFieldsOptions={listTriggeringFieldsOptions}
                                                                                listTriggeringImmediateFieldsOptions={listTriggeringImmediateFieldsOptions}
                                                                                listFileCompleteStatusesOptions={listFileCompleteStatusesOptions}
                                                                                listSettlementStatementStatusOptions={listSettlementStatementStatusOptions}
                                                                                listSeverReasonsData={listSeverReasonsData}
                                                                                listTransactionStatusTriggerData={listTransactionStatusTriggerData}
                                                                                listOperatorsOptions={listOperatorsOptions}
                                                                                listAgentStatusTriggerOptions={listAgentStatusTriggerOptions}
                                                                                selectedTransactionStatusTriggerOptions={selectedTransactionStatusTriggerOptions}
                                                                                setSelectedTransactionStatusTriggerOptions={setSelectedTransactionStatusTriggerOptions}
                                                                                setRadioPerformSelected={setRadioPerformSelected}
                                                                                radioPerformSelected={radioPerformSelected}
                                                                                setTriggerFieldTypeId={setTriggerFieldTypeId}
                                                                                setTriggerFieldTypeIdImmediate={setTriggerFieldTypeIdImmediate}
                                                                                triggerFieldTypeId={triggerFieldTypeId}
                                                                                triggerFieldTypeIdImmediate={triggerFieldTypeIdImmediate}
                                                                                recurringTriggerIds={recurringTriggerIds}
                                                                            />
                                                                        </Tab.Pane>
                                                                    }
                                                                </Tab.Content>
                                                            </Col>
                                                        </Row>
                                                    </Tab.Container>
                                                </div>
                                            </Row>

                                            <div className="form-action-buttons">
                                                <Button bsStyle="default" onClick={() => props.formCancelled()} className="button-group-margin" disabled={isBusy}>
                                                    <i className="fa fa-undo button-icon"></i>
                                                    Back
                                                </Button>
                                                <Button bsStyle="danger" variant="danger" onClick={(e) => submittedTemplateHandler(e)} type="submit" className="button-group-margin" disabled={!canEdit || isBusy}>
                                                    <i className="fa fa-save button-icon"></i>
                                                    {isBusy ? 'Saving...' : 'Save & Exit'}
                                                </Button>
                                            </div>
                                        </Form>
                                    </Panel.Body>
                                </Panel>
                            </div>
                        }
                    </Suspense>
                    : <Spinner text="Loading Activity Template..." />
                }
            </div>
        </>
    );
}

export default withAuthentication(withLayout(withForm(ActivityPlanTemplate)));